import { useSyncExternalStore } from "react";

import { getDeck, subscribeDeck, type DeckState } from "./deckStore";

/** 走査結果を購読する。参照は走査のたびにだけ変わる。 */
export function useDeck(): DeckState {
    return useSyncExternalStore(subscribeDeck, getDeck, getDeck);
}
